import React from 'react';
import { array, func, number, string, oneOfType, object, bool } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { equals, allPass, has } from 'ramda';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Box, Icon } from '@material-ui/core';

import { mapIndexed } from '../../../utils/helpers';

const styles = {
  whiteColor: {
    color: 'white',
  },
};

const MultiPicker = ({
  className,
  content,
  onChange,
  option = 12,
  selected,
  buttonContainerStyle,
  iconStyle,
  textStyle,
  spacing = 2,
  justify = 'flex-start',
  wrap = 'wrap',
  multi = false,
  size = 'medium',
  downSized = false,
}) => {
  const isIntl = allPass([has(['id']), has(['defaultMessage'])]);
  const isSelected = multi ? value => selected?.[value] : value => equals(selected, value);

  return (
    <Grid container className={className} spacing={spacing} justify={justify} wrap={wrap}>
      {mapIndexed(
        ({ testId, name, value, subContent, image, xs }, index) => (
          <Grid item key={index} xs={xs || option} style={{ width: '100%' }}>
            <Button
              id="multi-picker-button"
              data-testid={`multi-picker-button-${testId}`}
              className={`${isSelected(value) ? null : ''}`}
              style={{
                minWidth: '56px',
                height: '100%',
                ...(!isSelected(value) && {
                  background: '#F5F5F5',
                  color: '#6F7072',
                }),
                ...(textStyle && {
                  ...(isSelected(value) ? styles.whiteColor : { color: 'black' }),
                  ...textStyle,
                }),
              }}
              color="primary"
              fullWidth
              onClick={() => onChange(value)}
              variant="contained"
              name={typeof value === 'boolean' ? name?.defaultMessage : value}
              size={downSized ? 'small' : size}
            >
              <Box
                style={
                  subContent
                    ? {
                      display: 'flex',
                      flexDirection: 'column',
                      textAlign: 'left',
                      alignItems: 'flex-start',
                      width: '100%',
                    }
                    : { ...buttonContainerStyle }
                }
              >
                {image && (
                  <Icon
                    component={image}
                    style={isSelected(value) ? { ...styles.whiteColor, ...iconStyle } : { color: '#00238E', ...iconStyle }}
                  />
                )}
                <Box>{isIntl(name) ? <FormattedMessage id="" {...name} /> : name}</Box>
                {subContent &&
                  (typeof subContent === 'string' || isIntl(subContent) ? (
                    <>
                      <Box style={{ width: '100%', whiteSpace: 'pre-wrap', display: 'block', fontWeight: 'normal' }}>
                        {isIntl(subContent) ? <FormattedMessage id="" {...subContent} /> : subContent}
                      </Box>
                    </>
                  ) : (
                    subContent
                  ))}
              </Box>
            </Button>
          </Grid>
        ),
        content
      )}
    </Grid>
  );
};

MultiPicker.propTypes = {
  content: array,
  className: string,
  onChange: func,
  option: number,
  selected: oneOfType([bool, string, object]),
  buttonContainerStyle: object,
  iconStyle: object,
  textStyle: object,
  spacing: number,
  justify: string,
  wrap: string,
  multi: bool,
  size: string,
  downSized: bool,
};

export default MultiPicker;
